import type { Notification } from "~/apiclient/types.gen"

export const useGetNotifications = defineQuery(() => {
	const { ...query } = useQuery({
		key: () => ["notifications"],
		staleTime: 0,
		placeholderData: { items: [] as Notification[], unreadCount: 0 },
		query: async () => {
			// Fetch the full stored set (backend caps a user's notifications at 200);
			// the bell shows all of them (scrollable) so the unread badge matches the list.
			const { data, error } = await getUsersNotifications({ query: { pageSize: 200 } })
			if (error) {
				console.error("failed to get user notifications: ", error)
				return { items: [] as Notification[], unreadCount: 0 }
			}
			return { items: data?.items ?? [], unreadCount: Number(data?.unreadCount ?? 0) }
		}
	})
	return { ...query }
})
